import { Stack } from "@mui/material";
import ActionButton from "components/react-lib/generic-ui/ActionButton";
import TextInput from "components/react-lib/generic-ui/TextInput";
import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "firebaseApp";
import React, { useState } from "react";

export default function FindUserForm({onSearchCompleted, ...props}) {

  const [searching, setSearching] = useState();
  const [userInfo, setUserInfo] = useState("");

  const searchUserByField = async (field) => {
    const querySnap = await getDocs(
      query(collection(db, "userPublicProfiles"), where(field, "==", userInfo))
    );
    if (querySnap.empty) return null;
    const userSnap = querySnap.docs[0];
    return { id: userSnap.id, ...userSnap.data() };
  };

  const searchUserByFields = async (fields) => {
    for (const field of fields) {
      const user = await searchUserByField(field);
      if (user) return user;
    }
    return null;
  };

  const handleSearch = async () => {
    try {
      setSearching(true);
      const user = await searchUserByFields(["uid", "username"]);
      if(onSearchCompleted) {
        console.log(user);
        onSearchCompleted(user);
      }
    } catch(error) {
      console.log(error);
    } finally {
      setSearching(false);
    }
  }

  return (
    <Stack
      spacing={1}
      {...props}
    >
      <TextInput
        color="secondary"
        label="User query (name, email, id, username, ...)"
        value={userInfo}
        setValue={setUserInfo}
      />
      <ActionButton
        variant="contained"
        onClick={handleSearch}
        processing={searching}
        disabled={!userInfo}
      >
        Find User
      </ActionButton>
    </Stack>
  );
}
